import { useQuery } from '@tanstack/react-query';

import { fetchOCTableViewColumns } from '../data-provider/table-view-columns';

export const useGetOCTableViewColumns = (gridName = 'OverChargeClaims') => {
  return useQuery({
    queryFn: () => fetchOCTableViewColumns({ GridName: gridName }),
    queryKey: ['claims-over-charge-table-view-columns', gridName],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
